import { render, staticRenderFns } from "./peopleCollec.vue?vue&type=template&id=4932a7f2&scoped=true"
import script from "./peopleCollec.vue?vue&type=script&lang=js"
export * from "./peopleCollec.vue?vue&type=script&lang=js"
import style0 from "./peopleCollec.vue?vue&type=style&index=0&id=4932a7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932a7f2",
  null
  
)

export default component.exports